import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Avatar,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
} from "@mui/lab";
import { jobs } from "../data/jobs";
import { fadeIn, staggeredContainer } from "../utils/animations";

export const ResumeSection = () => {
  const theme = useTheme();

  const onHoverStyle = {
    "&:hover": {
      "& svg": {
        color: "secondary.main",
      },
    },
  };

  return (
    <Box sx={{ py: 8, backgroundColor: "background.paper" }}>
      <Container>
        <motion.div
          variants={staggeredContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "space-between" },
              alignItems: "center",
              mb: 6,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 600,
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              Experience
            </Typography>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              component="a"
              href="/perault_resume_2025.pdf"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: { xs: "none", sm: "flex" },
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
                ...onHoverStyle,
              }}
            >
              Download Resume
            </Button>
          </Box>

          <Timeline position="alternate-reverse" sx={{ mb: { xs: 8, md: 0 } }}>
            {jobs.length > 0
              ? jobs
                .sort((firstJob, nextJob) => firstJob.id - nextJob.id)
                .map((job, j_index) => (
                    <TimelineItem key={job.id}>
                      <TimelineSeparator>
                        <TimelineDot sx={{ p: 0 }}>
                          <Avatar
                            src={job.icon}
                            alt={job.company}
                            sx={{ width: 24, height: 24, padding: 0.45, backgroundColor: "background.default" }}
                          />
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>

                      <TimelineContent>
                        <motion.div
                          variants={fadeIn}
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.5, delay: j_index * 0.1 }}
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" } }}
                          >
                            {job.company}
                          </Typography>
                          <Typography
                            color="text.secondary"
                            sx={{
                              fontSize: { xs: "0.8rem", sm: "0.9rem" },
                            }}
                          >
                            {job.location}
                          </Typography>
                          <Typography
                            color="text.secondary"
                            sx={{
                              fontSize: { xs: "0.8rem", sm: "0.9rem" },
                              pb: 1,
                            }}
                          >
                            {job.office}
                          </Typography>
                          {job.roles.length > 0
                            ? job.roles
                              .sort((firstRole, nextRole) => firstRole.id - nextRole.id)
                              .map((role, r_index) => (
                                <Box key={r_index}>
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                    color="secondary"
                                    sx={{
                                      fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                    }}
                                  >
                                    <motion.span
                                      whileHover={{
                                        scale: 0.95,
                                        color: "#1976d2",
                                      }}
                                      whileTap={{ scale: 0.95 }}
                                      style={{ display: "inline-block" }}
                                    >
                                      {role.title}
                                    </motion.span>
                                  </Typography>
                                  <Typography
                                    color="text.secondary"
                                    variant="body2"
                                    sx={{
                                      fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                      pb: 1,
                                    }}
                                  >
                                    {role.date}
                                  </Typography>
                                </Box>
                              ))
                            : null}
                        </motion.div>
                      </TimelineContent>
                    </TimelineItem>
                  ))
              : null}
          </Timeline>

          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              component="a"
              href="/perault_resume_2025.pdf"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
                ...onHoverStyle,
              }}
            >
              Download Resume
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};
